import React from "react";
import ChatInput from "../components/ChatInput/ChatInput";
import "./Home.css";
import Question from "../components/Question/Question";
import UnlikeModal from "../components/UnlikeModal/UnlikeModal";
import Signin from "../pages/Login/Signin";
import Login from "./Login/Login";
function Home({ user }) {
  return (
    <div className="">
      <Question user={user} />
    </div>
  );
}

export default Home;
